import { Injectable } from '@angular/core';

import { DeleteCommandService } from 'pbc.angular';

import { IDeleteBewertungsAnlassRequest, IDeleteBewertungsAnlassResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class DeleteBewertungsAnlassCommandService extends DeleteCommandService<IDeleteBewertungsAnlassRequest, IDeleteBewertungsAnlassResponse> {
  readonly route = 'gutachten/settings/bewertungs-anlass';
}
